// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import ThemeProvider from './theme_provider';

export {useUserTheme, WithUserTheme} from './theme_context';

export default ThemeProvider;
